export enum ExpertAnswerCategory {
    PeriodCare = 'Period Care',
    IntimateCare = 'Intimate Care',
    Sexuality = 'Sexuality'
}
